export const environment = {
	production: true,

	// laravel api url
	//API_URL: "http://gpfield.localhost/api/v1/",
	//API_URL: "https://api-qa.gramophone.in/api/v1/",
	CDC_DEPO_ID: -2,
	CDC_DEPO_NAME: "INDORE DEPO",
	API_URL: "https://api.gramophone.in/api/v1/",

	//SOCKET_URL: "https://notify-dev.gramophone.in",
	SOCKET_URL: "https://notify.gramophone.in",

	// firebase configs
	FIREBASE_CONFIG: {
		apiKey: "AIzaSyBMeFElsx4yhvQoE6KDM0sq4jHThsU6vWg",
		authDomain: "gramophone-18.firebaseapp.com"
	},
	mixPanelToken: "1fb6a0f90d9f8e439a3b1f228b770afe",

	PAYMENT_TIMEOUT: 10
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts